import { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'

import type { Table } from '@rewardops/utils'

import { formatTableData } from '~/utils/table-utils'

type Props = {
  content: Table
}

function DynamicTable(props: Props) {
  const { content } = props
  const [rows, setRows] = useState<string[][]>([])

  useEffect(() => {
    setRows(formatTableData(content))
  }, [])

  return (
    <div className="col-span-2 mx-auto mb-16 mt-0 w-full max-w-6xl rounded-2xl bg-white bg-opacity-95 p-8 px-9 shadow-xl">
      <h2 className="mb-4 text-2xl font-bold text-gray-900">{content.title}</h2>
      <table className="w-full overflow-hidden rounded-2xl border border-gray-200 text-left">
        <thead>
          <tr className="bg-tenant-primary-color text-white">
            <th className="border-b border-gray-200 px-4 py-3 text-lg font-semibold first:rounded-tl-2xl">
              {content.heading1}
            </th>
            <th className="border-b border-gray-200 px-4 py-3 text-lg font-semibold last:rounded-tr-2xl">
              {content.heading2}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([col1, col2], idx) => (
            <tr
              key={idx}
              className={
                (idx % 2 === 0 ? 'bg-gray-50' : 'bg-white') +
                ' border-b border-gray-200 last:border-b-0'
              }
            >
              <td className="w-1/2 px-4 py-3 align-top text-gray-800">
                {col1}
              </td>
              <td className="px-4 py-3 align-top text-gray-800">
                <span
                  className="[&_a:hover]:underline [&_a]:text-tenant-primary-color"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(col2 || ''),
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DynamicTable
